import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f143389c"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "big-title"
}, "公司介绍", -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createTextVNode("广州颜如玉网络有限公司，是一家移动互联网公司。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 糖果择她app是公司旗下主营一款基于地理位置为全球用"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 户提供聚会、旅游、吃喝的全方位移动社交APP。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 全程真人认证+人工审核，丰富的兴趣圈和精准匹配用"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 户，可以定制专属你的个人隐私。 ")], -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "big-title"
}, "联系我们", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "content"
}, "yry888yry@163.com", -1));

const _hoisted_5 = [_hoisted_1, _hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: "hello",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, _hoisted_5, 512), [[_vShow, $setup.show]]), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => $setup.hideTip && $setup.hideTip(...args))
  }, null, 512), [[_vShow, $setup.show]])], 64);
}